export * from './gs-textarea-clipboard.component';
